import { render, staticRenderFns } from "./InvalidFeedback.vue?vue&type=template&id=2d3cfc95"
import script from "./InvalidFeedback.vue?vue&type=script&lang=js"
export * from "./InvalidFeedback.vue?vue&type=script&lang=js"
import style0 from "./InvalidFeedback.vue?vue&type=style&index=0&id=2d3cfc95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports